import Components from "../components";
import * as Turbo from "@hotwired/turbo";

const COOKIE = "live-update-list1";

class LiveUpdateList extends Components.Base {
  initialize() {
    this.$startButton = this.$el.find("#start-live-updates");
    this.$stopButton = this.$el.find("#stop-live-updates");
    this.$target = $(this.$el.data("live-update-target"));

    if ($.cookie(COOKIE)) {
      this.enableUpdates();
    } else {
      this.disableUpdates();
    }
  }

  deinitialize() {
    if (this.requestIsPending()) {
      this.xhr.abort();
    }
  }

  bind() {
    this.on("click", "#start-live-updates", () => this.enableUpdates());
    this.on("click", "#stop-live-updates", () => this.disableUpdates());
  }

  unbind() {
    this.stopTimer();
  }

  enableUpdates() {
    this.startTimer();
    $.cookie(COOKIE, 1, { path: "/", expires: 1 });
    this.$el.removeClass("stopped").addClass("started");
  }

  disableUpdates() {
    this.stopTimer();
    $.cookie(COOKIE, null, { path: "/" });
    this.$el.removeClass("started").addClass("stopped");
  }

  startTimer() {
    this.stopTimer();
    this.timer = window.setInterval(() => this.refreshPage(), 6 * 1000);
  }

  stopTimer() {
    if (this.timer) {
      window.clearInterval(this.timer);
    }
    this.timer = null;
  }

  requestIsPending() {
    return this.xhr && this.xhr.readyState !== 4;
  }

  refreshPage() {
    if (this.requestIsPending()) {
      return;
    }

    Turbo.cache.clear();

    this.xhr = $.ajax(document.location.href, {
      type: "get",
      dataType: "html",
      headers: { LiveUpdateList: 1 },
      success: (response) => {
        Components.instances.unloadFragment(this.$target);
        this.$target.html(response);
        Components.collection.loadFragment(this.$target);
      },
    });
  }
}

Components.collection.register({
  selector: ".c-live-update-list",
  klass: LiveUpdateList,
});
